import { render, staticRenderFns } from "./desktopWeeklySalesCalendar.vue?vue&type=template&id=08275586&"
import script from "./desktopWeeklySalesCalendar.vue?vue&type=script&lang=js&"
export * from "./desktopWeeklySalesCalendar.vue?vue&type=script&lang=js&"
import style0 from "./desktopWeeklySalesCalendar.vue?vue&type=style&index=0&id=08275586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports